import { FC, PropsWithChildren, ReactNode } from 'react';

import { AvailableCurrencies, CURRENCY_SYMBOLS, formatCost, formatCostInCents } from 'utils/clickme';
import { NON_BREAKING_SPACE } from 'utils/constants/common';

interface FormatMoneyProps {
    children: number | string;
    inCents?: boolean;
    forceShowCents?: boolean;
    render?: (amount: string, currencyNode: ReactNode) => JSX.Element;
    groupSeparator?: string;
    currency?: AvailableCurrencies;
}

const isNumber = (children: ReactNode): children is number => {
    return typeof children === 'number';
};

const isString = (children: ReactNode): children is string => {
    return typeof children === 'string';
};

const FormatMoney: FC<FormatMoneyProps & PropsWithChildren> = ({
    children,
    inCents = false,
    forceShowCents,
    render = (amount, currencyNode) => (
        <>
            {amount}
            {NON_BREAKING_SPACE}
            {currencyNode}
        </>
    ),
    groupSeparator,
    currency = AvailableCurrencies.RUR,
}) => {
    let value = children;
    if (isString(value)) {
        value = parseFloat(value);
    }
    if (!isNumber(value)) {
        return null;
    }
    const amount = inCents
        ? formatCostInCents(value, groupSeparator, forceShowCents)
        : formatCost(value, groupSeparator);
    const currencyNode = CURRENCY_SYMBOLS[currency];
    return render(amount, currencyNode);
};

export default FormatMoney;
